









































import { IGebruiker } from '@/model/IGebruiker';
import { VoorkeurenNotificaties } from '@/model/VoorkeurenNotificaties';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

@Component({
  validations: {}
})
export default class AppGebruikerGegevens extends Vue {
  @State(state => state.gebruiker)
  public gebruiker!: IGebruiker;
  @Action('gebruiker/getGebruiker')
  private getGebruiker!: (force?: boolean) => Promise<IGebruiker>;
  @Action('gebruiker/updateVoorkeurNotificaties')
  private updateVoorkeurNotificaties!: (voorkeurNotificaties: VoorkeurenNotificaties | undefined) => Promise<void>;

  public state: { voorkeurNotificaties: VoorkeurenNotificaties | undefined } = {
    voorkeurNotificaties: VoorkeurenNotificaties.Geen
  };

  created() {
    this.getGebruiker().then(g => {
      this.state.voorkeurNotificaties = g.voorkeurNotificaties;
    });
  }

  voorkeurNotificatiesUpdated(newVal: VoorkeurenNotificaties) {
    this.updateVoorkeurNotificaties(newVal);
    this.state.voorkeurNotificaties = newVal;
  }
}
